// @flow
import type { CartState } from './reducers/cart';
import { MACHINE_SKUS, VIRTUAL_SKUS } from './reducers/cart';
import { VSHELF_MASTER_LIST } from './constants';

export const processCartSku = (
	skus: Map<string, { [key: string]: any }> = new Map(),
	cartState: CartState
): { skus: Map<string, { [key: string]: any }>, cartState?: CartState, cartUpdated?: boolean } => {
	let { sku_json = {} } = cartState || {};
	let {
		skus: cartSkus = [],
		totalQty: skusTotalQty,
		totalAmount: skusTotalAmount,
		totalBillValue: skusTotalBillValue,
	} = sku_json[MACHINE_SKUS] || {};

	let { totalAmount, totalQty, totalBillValue } = cartState || {};
	let cartUpdated = false;
	if (!cartSkus.length || skus.size === 0) {
		return { skus };
	}

	cartSkus = cartSkus.filter((cartSku) => !cartSku.isVirtualSku);
	const cartSkuJSON = cartSkus.map((cartSku: any) => {
		let tempCartSku = cartSku;
		let { purchased_qty = 0, is_sample = false, amount = 0 } = cartSku;

		let liveSku = skus.get(cartSku.key);
		if (typeof liveSku === 'object') {
			let purchasedQty = +liveSku.purchasedQty || 0;
			const qty = +liveSku.qty || 0;
			const { is_sample: sampleSku, selling_price, is_offer, offer_price, mrp } = liveSku;
			if (purchasedQty === 0) {
				if (!is_sample) {
					const sampleCartSku = cartSkus.find((sku) => sku.key === cartSku.key && cartSku.is_sample);
					if (sampleCartSku) {
						const { purchased_qty: samplePurchasedQty = 0 } = sampleCartSku;
						if (!sampleSku) {
							purchased_qty += samplePurchasedQty;
						} else {
							purchasedQty += samplePurchasedQty;
						}
					}
				} else if (!sampleSku) {
					const cartSkuData = cartSkus.find((sku) => sku.key === cartSku.key && !cartSku.is_sample);
					if (cartSkuData) {
						cartSkuData.purchased_qty += purchased_qty;
						cartSkuData.amount += (cartSkuData.amount / cartSkuData.purchased_qty) * purchased_qty;
						cartSkuData.totalMRP += +mrp * purchased_qty;
					} else {
						tempCartSku = {
							...tempCartSku,
							is_sample: false,
							amount: (is_offer ? +offer_price : +selling_price) * purchased_qty,
							totalMRP: +mrp * purchased_qty,
						};
					}
					cartUpdated = true;
				}
			} else if (is_sample && !sampleSku) {
				tempCartSku = null;
				return true;
			}

			const leftQty = qty - purchasedQty;
			if (leftQty - purchased_qty < 0) {
				cartUpdated = true;
				if (leftQty > 0) {
					tempCartSku = {
						...tempCartSku,
						purchased_qty: leftQty,
						amount: (amount / purchased_qty) * leftQty,
						totalMRP: +mrp * leftQty,
					};

					skusTotalQty -= purchased_qty - leftQty;
					skusTotalAmount -= (purchased_qty - leftQty) * (amount / purchased_qty);
					skusTotalBillValue -= (purchased_qty - leftQty) * +mrp;
					totalQty -= purchased_qty - leftQty;
					totalAmount -= (purchased_qty - leftQty) * (amount / purchased_qty);
					totalBillValue -= (purchased_qty - leftQty) * +mrp;
					// updatedSkuMap = [...value];
					liveSku = {
						...liveSku,
						purchasedQty: liveSku.purchasedQty ? +liveSku.purchasedQty + leftQty : leftQty,
					};
				} else {
					tempCartSku = null;
					skusTotalQty -= purchased_qty;
					skusTotalAmount -= purchased_qty * (amount / purchased_qty);
					skusTotalBillValue -= purchased_qty * +mrp;
					totalQty -= purchased_qty;
					totalAmount -= purchased_qty * amount;
					totalBillValue -= purchased_qty * +mrp;
				}
			} else {
				liveSku = {
					...liveSku,
					purchasedQty: liveSku.purchasedQty ? +liveSku.purchasedQty + purchased_qty : purchased_qty,
				};
			}
			skus.set(cartSku.key, liveSku);
		}

		return tempCartSku;
	});

	if (cartUpdated) {
		cartState = {
			...cartState,
			sku_json: {
				...sku_json,
				[MACHINE_SKUS]: {
					totalQty: skusTotalQty,
					totalAmount: skusTotalAmount,
					totalBillValue: skusTotalBillValue,
					skus: cartSkuJSON.filter((cartSku) => !!cartSku),
				},
			},
			totalAmount,
			totalQty,
			totalBillValue,
		};
	}

	return {
		skus,
		cartState,
		cartUpdated,
	};
};

export const processCartVSku = (
	skus: Map<string, Map<string, { [key: string]: mixed }>> = new Map(),
	cartState: CartState,
	skuShelfMap: Map<string, Set<string>>
): { [key: string]: any } => {
	let { sku_json = {} } = cartState || {};
	let { totalAmount, totalQty, totalBillValue } = cartState || {};
	let {
		skus: cartSkus = [],
		totalQty: skusTotalQty,
		totalAmount: skusTotalAmount,
		totalBillValue: skusTotalBillValue,
	} = sku_json[VIRTUAL_SKUS] || {};

	let cartUpdated = false;
	if (!cartSkus.length || skus.size === 0) {
		return skus;
	}

	// cartSkus = cartSkus.filter((cartSku) => cartSku.isVirtualSku || cartSku.action === VSHELF_MACHINE_SKU);
	const cartSkuJSON = cartSkus.map((cartSku: any) => {
		// const { skuVirtualKey, action } = cartSku;
		// const { key } = cartSku;
		// if (action === VSHELF_MACHINE_SKU && skuVirtualKey) {
		// 	key = skuVirtualKey;
		// }

		let tempCartSku = cartSku;
		let { purchased_qty = 0, is_sample = false, amount = 0, key } = cartSku;
		const podSkus = skus.get(VSHELF_MASTER_LIST);
		const updatedSkuMap = new Map<string, { [key: string]: mixed }>(podSkus);
		if (podSkus) {
			const liveSku = podSkus.get(key);
			if (liveSku && typeof liveSku === 'object') {
				let purchasedQty = +liveSku.purchasedQty || 0;
				const qty = +liveSku.qty || 0;
				const { is_sample: sampleSku, selling_price, is_offer, offer_price, mrp } = liveSku;
				if (purchasedQty === 0) {
					if (!is_sample) {
						// cart sku not sample
						const sampleCartSku = cartSkus.find((sku) => sku.key === cartSku.key && cartSku.is_sample);
						if (sampleCartSku) {
							const { purchased_qty: samplePurchasedQty = 0 } = sampleCartSku;
							if (!sampleSku) {
								purchased_qty += samplePurchasedQty;
							} else {
								purchasedQty += samplePurchasedQty;
							}
						}
					} else if (!sampleSku) {
						const cartSkuData = cartSkus.find((sku) => sku.key === cartSku.key && !cartSku.is_sample);
						if (cartSkuData) {
							cartSkuData.purchased_qty += purchased_qty;
							cartSkuData.amount += (cartSkuData.amount / cartSkuData.purchased_qty) * purchased_qty;
							cartSkuData.totalMRP += +mrp * purchased_qty;
						} else {
							tempCartSku = {
								...tempCartSku,
								is_sample: false,
								amount: (is_offer ? +offer_price : +selling_price) * purchased_qty,
								totalMRP: +mrp * purchased_qty,
							};
						}
						cartUpdated = true;
					}
				} else if (is_sample && !sampleSku) {
					tempCartSku = null;
					return tempCartSku;
				}

				let skuData = podSkus.get(key);
				const leftQty = qty - purchasedQty;
				if (leftQty - purchased_qty < 0) {
					cartUpdated = true;
					if (leftQty > 0) {
						tempCartSku = {
							...tempCartSku,
							purchased_qty: leftQty,
							amount: (amount / purchased_qty) * leftQty,
							totalMRP: +mrp * leftQty,
						};

						skusTotalQty -= purchased_qty - leftQty;
						skusTotalAmount -= (purchased_qty - leftQty) * (amount / purchased_qty);
						skusTotalBillValue -= (purchased_qty - leftQty) * +mrp;
						totalQty -= purchased_qty - leftQty;
						totalAmount -= (purchased_qty - leftQty) * (amount / purchased_qty);
						totalBillValue -= (purchased_qty - leftQty) * +mrp;

						skuData = {
							...liveSku,
							purchasedQty: liveSku.purchasedQty ? +liveSku.purchasedQty + leftQty : leftQty,
						};
					} else {
						tempCartSku = null;
						skusTotalQty -= purchased_qty;
						skusTotalAmount -= purchased_qty * (amount / purchased_qty);
						skusTotalBillValue -= purchased_qty * +mrp;
						totalQty -= purchased_qty;
						totalAmount -= purchased_qty * amount;
						totalBillValue -= purchased_qty * +mrp;
					}
				} else {
					skuData = {
						...liveSku,
						purchasedQty: liveSku.purchasedQty ? +liveSku.purchasedQty + purchased_qty : purchased_qty,
					};
				}

				skuData && updatedSkuMap.set(key, skuData);
				skus.set(VSHELF_MASTER_LIST, updatedSkuMap);
				let shelfSet = skuShelfMap.get(key);
				if (skuData && shelfSet) {
					const shelfArray = [...shelfSet];
					shelfArray
						.filter((shelf) => shelf !== VSHELF_MASTER_LIST)
						.forEach((shelf) => {
							const skuMap = skus.get(shelf);
							if (skuMap && skuData) {
								skuMap.set(key, skuData);
								skus.set(shelf, skuMap);
							}
						});
				}
			}
		}

		return tempCartSku;
	});

	if (cartUpdated) {
		cartState = {
			...cartState,
			sku_json: {
				...sku_json,
				[VIRTUAL_SKUS]: {
					totalQty: skusTotalQty,
					totalAmount: skusTotalAmount,
					totalBillValue: skusTotalBillValue,
					skus: cartSkuJSON.filter((cartSku) => !!cartSku),
				},
			},
			totalAmount,
			totalQty,
			totalBillValue,
		};
	}

	return {
		skus,
		cartState,
		cartUpdated,
	};
};

export const getCookie = (name: string) => {
	if (window.localStorage) {
		return localStorage.getItem(name);
	}

	name = name + '=';
	const cookie = document.cookie;
	const ca = cookie.split(';');
	for (let i = 0; i < ca.length; i++) {
		let c = ca[i];
		while (c.charAt(0) === ' ') {
			c = c.substring(1);
		}
		if (c.indexOf(name) === 0) {
			return c.substring(name.length);
		}
	}
	return '';
};

export const setCookie = (name: string, value: string) => {
	if (window.localStorage) {
		return localStorage.setItem(name, value);
	}

	let expiry = new Date();
	expiry.setTime(expiry.getTime() + 3600000 * 24 * 365);
	document.cookie = `${name}=${value};expires=${expiry.toUTCString()};path=/`;
};

export const deleteCookie = (name: string) => {
	if (window.localStorage) {
		return localStorage.removeItem(name);
	}
	document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;;path=/';
};

export const deleteAllCookies = () => {
	if (window.localStorage) {
		return localStorage.clear();
	}

	const cookie = document.cookie;
	const ca = cookie.split(';');
	for (let i = 0; i < ca.length; i++) {
		let c = ca[i];
		c = c.trim();
		const name = c.split('=')[0];
		if (name) {
			document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;;path=/';
		}
	}
};

const USER_KEYS = ['user', 'sessionId'];
export const deleteUserCookies = () => {
	if (window.localStorage) {
		return USER_KEYS.forEach((key) => localStorage.removeItem(key));
	}

	const cookie = document.cookie;
	const ca = cookie.split(';');
	for (let i = 0; i < ca.length; i++) {
		let c = ca[i];
		c = c.trim();
		const name = c.split('=')[0];
		if (USER_KEYS.includes(name)) {
			document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;;path=/';
		}
	}
};

export const fetchLatlng = async () => {
	return new Promise((resolve, reject) => {
		if ('geolocation' in navigator === false) {
			reject('No geolocation service');
		} else {
			navigator.geolocation.getCurrentPosition(
				(position) => {
					if (position && position.coords) {
						return resolve({
							latitude: position.coords.latitude,
							longitude: position.coords.longitude,
						});
					}
					resolve();
				},
				(error) => reject(error),
				{
					enableHighAccuracy: false,
					maximumAge: 0,
					timeout: 5000,
				}
			);
		}
	});
};

export const calendarConfig = {
	sameDay: '[TODAY] LT',
	lastDay: '[YESTERDAY] LT',
	nextDay: 'DD MMM Y LT',
	lastWeek: 'DD MMM Y LT',
	nextWeek: 'DD MMM Y LT',
	sameElse: 'DD MMM Y LT',
};

export function isMobile(userAgent: string): boolean {
	return userAgent.search(/Android|iPhone/) >= 0;
}

export function isAndroid(userAgent: string): boolean {
	return userAgent.search(/Android/) >= 0;
}

export function isIPhone(userAgent: string): boolean {
	return userAgent.search(/iPhone/) >= 0;
}

export function isChrome(userAgent: string): boolean {
	return userAgent.search(/Chrome/) >= 0;
}

export function isFirefox(userAgent: string): boolean {
	return userAgent.search(/Firefox/) >= 0;
}

export function isSafari(userAgent: string): boolean {
	return !isChrome(userAgent) && !isFirefox(userAgent) && userAgent.search(/Safari/) >= 0;
}

export class GeoLocationError extends Error {
	name = 'GeoLocationError';
}